module.exports = __webpack_public_path__ + "img/2495262.jpg";